export default __webpack_public_path__ + "static/media/guide36.32a24a39.png";